import stack from './stack.json'
export default {api_endpoint:stack.ServiceEndpoint}